import { combineEpics } from 'redux-observable';
import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { GT_ESTIMATE_ACTION_TYPES as AT } from './GTEstimate.actions';

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.GT_ESTIMATE_FETCH_DATA, Api.fetchGTEstimateData],
    [AT.GT_ESTIMATE_RERUN_DATA, Api.rerunGTEstimateData],
    [AT.GT_ESTIMATE_UPDATE_DATA, Api.updateEstimations],
    [AT.GT_ESTIMATE_RESET_PROCESSING, Api.resetProcessing],
    [AT.GT_ESTIMATE_DELETE_DATA, Api.deleteEstimations]
  )
);
